import { User } from '../woo_services.module/shared-types';
import { UserRole } from './user-roles';

const AGENCY_ROLES = [UserRole.agencyAdmin, UserRole.agencyUser, UserRole.agencyUserAtCustomer];
const AGENCY_LEVEL_ROLES = [UserRole.agencyAdmin, UserRole.agencyUser];

/**
 * An agency admin may update, deactivate and reset the password
 * of a user only when that user holds nothing but agency roles, and the agency admin administers every agency the
 * user belongs to.
 */
export function agencyAdminManagesUser(agencyAdmin: User, target: User): boolean {
  const administeredAgencyIds = (agencyAdmin?.roles ?? [])
    .filter((role) => role.name === UserRole.agencyAdmin)
    .map((role) => role.resource_id);
  const targetRoles = target?.roles ?? [];
  const targetAgencyIds = targetRoles
    .filter((role) => AGENCY_LEVEL_ROLES.includes(role.name))
    .map((role) => role.resource_id);

  return (
    administeredAgencyIds.length > 0 &&
    targetRoles.length > 0 &&
    targetRoles.every((role) => AGENCY_ROLES.includes(role.name)) &&
    targetAgencyIds.length > 0 &&
    targetAgencyIds.every((id) => administeredAgencyIds.includes(id))
  );
}
